import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  type User,
  type UserCredential,
} from "firebase/auth";

const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);
initializeApp(firebaseConfig);

export const auth = getAuth();

const provider = new GoogleAuthProvider();
// UX hint only — pre-selects the Workspace account in the Google picker. Real
// authorization is the grant check in user-insights' /v0/auth/token endpoint.
// provider.setCustomParameters({ hd: "augmodo.com" });

export function signIn(): Promise<UserCredential> {
  return signInWithPopup(auth, provider);
}

export function signOut(): Promise<void> {
  return auth.signOut();
}

export function getCurrentUser(): Promise<User | null> {
  return new Promise((resolve) => {
    const remove = auth.onAuthStateChanged((user) => {
      remove();
      resolve(user);
    });
  });
}
